import { ProjectManagementState } from '@/store/ProjectManagement/ProjectManagementRoot';
import { MutationTree } from 'vuex';

import { IPMChart, IPMChartDpc, IPMChartVersion } from '@/ship/Models/IProjectManagement';
import { ChartVersion, Structure } from '@/ship/Models/ProjectManagement';
import User from '@/ship/Models/User';
import { cloneDeep } from 'lodash';

export const mutations: MutationTree<ProjectManagementState> = {
    SET_CHART(state, chart: IPMChart) {
        state.chart = chart;
    },

    RESET_CHART(state) {
        state.chart = null;
    },

    UPDATE_CHART_BY_ID(state, chart: IPMChart) {
        if (state.chart) {
            const versions = state.chart.versions;
            state.chart = { ...chart, versions };
        }
    },

    UPDATE_CHART_VERSION_BY_ID(state, version: IPMChartVersion) {
        if (state.chart) {
            if (state.chart.versions) {
                const item = state.chart.versions.data.find(({ id }) => id === version.id);

                if (item) Object.assign(item, version);
            }
        }
    },

    /**
     * remove version by id from chart version include
     * @param state
     * @param versionId
     */
    REMOVE_CHART_VERSION_BY_ID(state, versionId: number) {
        if (state.chart) {
            const versions = { data: [...state.chart.versions!.data].filter(({ id }) => id !== versionId) };
            state.chart = { ...state.chart, versions };
        }
    },

    CLEAR_CHART(state) {
        state.chart = null;
    },

    ADD_CHART_VERSION(state, version: IPMChartVersion) {
        if (state.chart) {
            const versions = {
                data: [...state.chart.versions!.data, version],
            };
            state.chart = { ...state.chart, versions };
        }
    },

    SET_CHART_VERSION(state, chartVersion: ChartVersion) {
        state.chartVersion = cloneDeep(chartVersion);
        state.chartVersionTasks = cloneDeep(chartVersion.tasks.data);
    },

    SET_USERS(state, users: User[]) {
        state.users = cloneDeep(users);
    },

    UPDATE_STRUCTURE_TASKS(state, tasks: Structure[]) {
        state.chartVersionTasks = cloneDeep(tasks);
    },

    SET_DPC_LIST(state, dpcList: IPMChartDpc[]) {
        state.dpcList = dpcList;
    },

    SET_DPC_EXEC_LIST(state, dpcExecList) {
        state.dpcExecList = dpcExecList;
    },

    SET_WEEKLY_REPORT(state, weeklyReport) {
        state.weeklyReport = cloneDeep(weeklyReport);
    },
};
export default mutations;
